import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Flex, Text, Image, Button, VStack } from "@chakra-ui/react";

import starImg from "../../assets/star.png";
import img1 from "../../assets/multiple-kids.png";
import arrowStarImg from "../../assets/arrow-star.png";

const Thankyou = () => {
  const navigate = useNavigate();

  return (
    <Flex
      justify="center"
      align="center"
      height="100vh"
      bg="white"
      border="1px solid #2a4567"
      position="relative"
      boxShadow="0px 4px 20px rgba(0, 0, 0, 0.25)"
    >
      {/* Left Content */}
      <Box
        flex={1}
        justifyContent="center"
        alignItems="center"
        display={"flex"}
      >
        <VStack align="flex-start" spacing={4} width={560}>
          {/* <VStack marginLeft={8}>
            <Image src={starImg} alt="Star Image" />
          </VStack> */}

          <Text
            fontFamily={"PlusJakartaSansSemiBold"}
            fontSize={"48px"}
            lineHeight={"60px"}
            color={"#000000"}
            textTransform={"capitalize"}
          >
            Thanks for Submitting. We'll be in{" "}
            <Text as="span" textDecoration={"underline"}>
              Touch
            </Text>
            .
          </Text>
          <Flex>
            <VStack width={540}>
              <Text
                fontFamily={"PlusJakartaSansRegular"}
                fontSize={"18px"}
                lineHeight={"28px"}
                color={"#898989"}
                flex={1}
              >
                Thanks for showing your interest it usually takes up-to 2 days
                for us to respond. If you don’t receive any updates from us then
                please have a look in your spam folder or don’t hesitate to
                reach out to us at{" "}
                <a href="mailto:info@kidswearcollective.com">
                  <Text
                    as="span"
                    textDecoration={"underline"}
                    color={"#456EFF"}
                    cursor={"pointer"}
                    fontSize={'18px'}
                  >
                    info@kidswearcollective.com
                  </Text>
                </a>
              </Text>
            </VStack>
            {/* <Image
              src={arrowStarImg}
              alt="Star Image"
              //   width={136}
              height={136}
              marginTop={"-48px"}
            /> */}
          </Flex>
          <Flex mt={5} gap={4}>
            <Button
              variant="outline"
              bgColor={"transparent"}
              colorScheme="#456EFF"
              borderRadius={"12px"}
              fontFamily={"PlusJakartaSansSemiBold"}
              fontSize={"16px"}
              lineHeight={"20px"}
              color={"#456EFF"}
              textAlign={"center"}
              w={"175px"}
              h={"48px"}
              onClick={() => navigate('/')}
            >
              CLOSE
            </Button>
          </Flex>
        </VStack>
      </Box>
      {/* Right Image */}
      <Box
        flex={1}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Image
          src={img1}
          alt="Kids Fashion"
          objectFit="cover"
          width={550}
          height={440}
        />
      </Box>
    </Flex>
  );
};

export default Thankyou;
